import React, { Component } from "react";
import clsx from "clsx";
import EscapeOutside from "react-escape-outside";
import Checkbox from "@material-ui/core/Checkbox";

import "./styles/customSelect.scss";
import InfoBarSelection from "./components/InfoBarSelection";
import BounceLoader from "react-spinners/BounceLoader";

import SearchBar from "../SearchBar/SearchBar";

export default class CustomSelect extends Component {
  constructor(props) {
    super(props);
    const isMultiSelect = this.props.isMultiSelect
      ? this.props.isMultiSelect
      : false;
    const initialValues = this.getInitialValues(
      props.item.value,
      isMultiSelect
    );
    this.state = {
      isOpen: false,
      checkboxSelection: {},
      localValues: initialValues,
      searchTerm: "",
    };
  }

  getInitialValues = (value, isMultiSelect) => {
    if (!value) return [];
    if (isMultiSelect) {
      return Array.isArray(value) ? value : [];
    } else {
      return Array.isArray(value)
        ? value.length > 0
          ? [value[0]]
          : []
        : value.length === 0
          ? []
          : [value];
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const isMultiSelect = this.props.isMultiSelect
      ? this.props.isMultiSelect
      : false;
    if (this.props.item.value !== prevProps.item.value) {
      const newValues = this.getInitialValues(
        this.props.item.value,
        isMultiSelect
      );
      this.setState({ localValues: newValues });
    }
  }

  toggleOpen = (e) => {
    this.setState({ searchTerm: "" });
    if (this.props.item.options?.length === 0) return;
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };
  onChange = (selection) => {
    const isMultiSelect = this.props.isMultiSelect;
    if (isMultiSelect && isMultiSelect === true) {
      this.toggleCheckBox(selection);
    } else this.changleSingleSelectValue(selection);
  };

  changleSingleSelectValue = (selection) => {
    this.setState({ localValues: [selection.id] }, () => this.onConfirm());
  };

  toggleAllCheckbox = () => {
    const options = this.props.item.options;
    this.setState({ searchTerm: "" });
    var values = [];
    if (this.state.localValues.length !== options.length)
      //if all not selected
      options.map((option) => {
        values.push(option.id);
      });
    this.setState({ localValues: values });
  };

  toggleCheckBox = (selection) => {
    //console.log(selection);
    const values = this.state.localValues;
    if (!values.includes(selection.id)) {
      values.push(selection.id);
    } else {
      const index = values.indexOf(selection.id);
      // console.log(index);
      if (index > -1) {
        // only splice array when item is found
        values.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
    this.setState({ localValues: values });
  };

  onSearch = (e) => {
    this.setState({ searchTerm: e.toLowerCase() });
  };

  filterSearch = (i) => {
    if (this.state.searchTerm === "") return true;
    return i.name.toLowerCase().includes(this.state.searchTerm);
  };

  onConfirm = () => {
    this.setState({ isOpen: false });
    var selectionList = [...this.state.localValues];

    //MULTI-SELECT;
    if (this.props.isMultiSelect && this.props.isMultiSelect === true) {
      this.props.handleChange({
        target: { key: this.props.item.key, value: selectionList },
      });
    }
    //SINGLE-SELECT
    else
      this.props.handleChange({
        target: { key: this.props.item.key, value: selectionList[0] },
      });
  };

  onClickAway = () => {
    const isMultiSelect = this.props.isMultiSelect
      ? this.props.isMultiSelect
      : false;
    if (
      !isMultiSelect ||
      (this.state.localValues.length === 0 && isMultiSelect)
    )
      this.setState({ isOpen: false });
  };

  render() {
    const item = this.props.item;
    const isOpen = this.state.isOpen;
    const isMultiSelect = this.props.isMultiSelect
      ? this.props.isMultiSelect
      : false;
    const values = this.state.localValues;
    const isRequired = this.props.isRequired ? this.props.isRequired : false;
    const isSearchable =
      this?.props.isSearchable === undefined ||
      this?.props.isSearchable === true;

    return (
      <EscapeOutside onEscapeOutside={this.onClickAway}>
        <div
          className={clsx(
            isOpen
              ? "dexter-custom-select-container active"
              : "dexter-custom-select-container",
            this.props.isGlassTheme && !isOpen && "glass-theme"
          )}
          onClick={this.toggleOpen}
          style={{
            cursor: item?.options?.length ? "pointer" : "not-allowed",
            backgroundColor: item?.options?.length ? "" : "rgb(237 239 245)",
            ...this.props.style,
          }}
        >
          {!item.options && (
            <div className="select-spinners-containers">
              <BounceLoader size={20} />
            </div>
          )}
          <InfoBarSelection
            isActive={item?.options?.length}
            item={item}
            values={values}
            isRequired={isRequired}
            showExpandIndicator={this?.props?.showExpandIndicator}
            isExpanded={isOpen}
          />

          {item && item.options && item.options.length !== 0 && isOpen && (
            <div
              className="selection-overlay"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {isSearchable && item.options.length > 3 && (
                <div className="customselect-search-bar-container">
                  {" "}
                  <SearchBar
                    value={this.state.searchTerm}
                    onSearch={this.onSearch}
                  />
                </div>
              )}
              {isMultiSelect && (
                <div
                  onClick={(e) => {
                    this.toggleAllCheckbox();
                  }}
                  className="custom-select-all"
                >
                  {item.options.length === this.state.localValues.length
                    ? "Deselect All"
                    : "Select All"}
                </div>
              )}
              <div className="options-list-select">
                {item.options.filter(this.filterSearch).map((option) => {
                  //
                  const status = values.includes(option.id);

                  //
                  return (
                    <div
                      key={option.id}
                      className={
                        !status ? "option-select" : "option-select active"
                      }
                      onClick={(e) => {
                        this.onChange(option);
                      }}
                    >
                      {isMultiSelect && (
                        <Checkbox
                          //   checked={item.value.indexOf(option.id) > -1}
                          checked={status}
                        />
                      )}
                      {option.name}
                    </div>
                  );
                })}
              </div>
              {isMultiSelect && (
                <button
                  onClick={(e) => {
                    this.onConfirm();
                  }}
                  className="confirm-button"
                  //disabled={values.length === 0}
                >
                  Done
                </button>
              )}
            </div>
          )}
        </div>
      </EscapeOutside>
    );
  }
}

// const InfoBarSelection = ({ item, values }) => {
//   // console.log(values);
//   return (
//     <div className="info-bar-selection-container">
//       {item.icon && <img src={item.icon} />}
//       <div className="info">
//         <p className={values.length > 0 ? "label small" : "label"}>
//           {item.label}
//         </p>
//         {values.length > 0 && (
//           <p className="selection">{formatSelections(values, item.options)}</p>
//         )}
//       </div>
//     </div>
//   );
// };
